// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cc2636d8","455":"e04e1fe0","977":"e38f3b5c"}[chunkId] + ".chunk.js";
};